import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import ReactPlayer from 'react-player'
import classes from 'classnames';
import {validateVideo} from '../../../../utils/validationUtils';
import {Button, buttonTypes} from "../../../../components/Button/index";


class UploadVideo extends React.Component {
  constructor(props) {
    super(props);
    this.handleDrop = this.handleDrop.bind(this);
    this.state = {
      error: {},
      video: {}
    }
  }

  componentWillMount() {
    this.setState({
      error: this.props.error,
    })
  }

  componentWillReceiveProps(next) {
    this.setState({
      error: next.error,
    });
    if (next.tourVideos && next.tourVideos[0] && next.tourVideos[0].videoUrl) {
      this.setState({video: {}})
    }
  }

  handleDrop(video) {
    const validate = validateVideo(video[0]);
    if (validate.isValid) {
      this.setState({video: video[0]}, () => {
        this.props.onNewVideo(this.state.video)
      })
    } else {
      this.setState({error: {...this.state.error, video: validate.error}})
    }
  };

  render() {
    const playing = false;
    const controls = true;
    const {
      error,
      video,
    } = this.state;

    const {
      tourVideos,
      deleteVideo,
      blockType,
      isPendingUploadVideo,
    } = this.props;


    const uploadVideo =
      blockType !== 'edit' ?
        classes('create-tour__video', {isDone: Object.keys(video).length === 1})
        :
        classes('create-tour__video',
          {process: Object.keys(video).length !== 0 && tourVideos.length === 0},
          {load: tourVideos.length > 0 && Object.keys(video).length > 0},
          {isDone: tourVideos.length > 0 && Object.keys(video).length === 0}
        );


    return (
      <div className={uploadVideo}>
        {
          error.video ?
            <span className="error-block">{error.video}</span> : null
        }

        {
          tourVideos && tourVideos.length > 0 && tourVideos[0].videoUrl ?
            <ReactPlayer
              playing={playing}
              controls={controls}
              url={tourVideos[0].videoUrl}
              width="100%"
              height="100%"
            /> : null
        }
        {
          video.preview && blockType !== 'edit' ?
            <ReactPlayer
              playing={playing}
              controls={controls}
              url={video.preview}
              width="100%"
              height="100%"
            /> : null
        }
        {
          tourVideos && tourVideos.length > 0 && tourVideos[0].videoUrl ?
            <Button
              type={buttonTypes.DEACTIVATED}
              name="Delete Video"
              onClick={() => {
                deleteVideo(tourVideos[0].videoId)
              }}
            /> :
            <div className="create-tour__dropZone-wrap">
              {
                blockType === 'edit' && tourVideos.length > 0 ?
                  <div className="create-tour__video-load">
                    <p className="create-tour__video-processing">Video In Loading</p>
                    <img src="/assets/img/loader.gif" alt="loader" />
                  </div> :
                  <div className="create-tour__drop-zone">
                    {
                      !isPendingUploadVideo ?
                        <Dropzone
                          className="create-tour__video-body"
                          style={{width: '100%'}}
                          accept="video/*"
                          onDrop={this.handleDrop}
                        >
                          {
                            video.name ?
                              <p className="create-tour__video-name">{video.name}</p> : null
                          }
                          <div className="create-tour__video-content">
                            <ion-icon
                              name="recording"
                            />
                            {
                              video.name ?
                                <Button
                                  type={buttonTypes.AUTHENTICATION}
                                  name="Change video"
                                /> :
                                <p className="create-tour__video-string">Add video here</p>
                            }
                          </div>
                        </Dropzone> :
                        <div className="create-tour__video-processing">Video In Processing</div>
                    }
                  </div>
              }
            </div>
        }
      </div>
    )
  }
}

UploadVideo.propTypes = {
  blockType: PropTypes.string,
  error: PropTypes.object,
  tourVideos: PropTypes.array,
  onNewVideo: PropTypes.func,
  // showPlayer: PropTypes.func,
  deleteVideo: PropTypes.func,
  isPendingUploadVideo: PropTypes.bool,
};

export default UploadVideo;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/UploadVideo.js